import React, { useState } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

export const SelectTimezoneField = ({ timezone, options, field, form }) => {
    const { t } = useTranslation();

    const timezoneOptions = () => options?.map((item) => ({ value: item.value, label: item.item }));

    const handleChange = ({ value, label }) => {
        form.setFieldValue('timezone', { value, label });
    };

    const customSelectStyles = {
        input: (base) => ({ ...base, boxShadow: 'none',
        '*': {boxShadow: 'none !important',outline: 'none !important'}}),
    };

    return (
        <Select
            options={timezoneOptions()}
            name={field.name}
            value={timezone}
            onChange={handleChange}
            onBlur={field.onBlur}
            placeholder={t("Select timezone")}
            styles={customSelectStyles}
        />
    );
};
